export default __webpack_public_path__ + "static/media/Immagine_6.13d88b45.jpg";